// const MAINTAINANCE_URL = 'http://localhost:10445'
const MAINTAINANCE_URL = `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}`

const CodeMaintainanceApiUrls = {
  MAINTAINANCE_CODE: `${MAINTAINANCE_URL}/code-maintenance/get`
}

export default CodeMaintainanceApiUrls